// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7vmQp","left":"styles_left__3K3WX","desktopActions":"styles_desktopActions__2SjUj","title":"styles_title__2Hpuo"};